// @flow
import React from 'react';
import { useDispatch } from 'react-redux';
import {
    clearModalContent,
    setModalContent
} from 'src/redux/modules/modalEvent';

import './ClinicianMobileDetails.scss';
import { Typography } from "src/latest/src/components";
import Avatar from 'src/components/base/Avatar/Avatar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeftLong,faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { getMeetingAvailabilityGradient } from './Utils/utils';

type Props = {
    therapistInfo?: any
}
const ClinicianMobileDetails = ({ therapistInfo }: Props): ReactElement<any> => {
    const dispatch = useDispatch();

    const handleClick = () => {
        const handleBackClick = () => {
            dispatch(clearModalContent());
        };

        dispatch(
            setModalContent({
                modalContent: (
                    <>
                        <div className='therapist-detail-mobile'>
                            <div className='therapist-card'>
                                <div className='Avatar-Clinician-model'>
                                    {' '}
                                    <Avatar
                                        photoUrl={
                                            therapistInfo?.profile_picture
                                        }
                                        fullName = {therapistInfo?.therapist_name}
                                        size='100px'
                                    />
                                </div>
                                <div className='mobile-therapistname'>
                                    <Typography
                                        weight='bold'
                                        variant='size-20'
                                        color='color-2'
                                    >
                                        {' '}
                                        {/* {therapistInfo?.therapist_name.length > 21 ? `${therapistInfo?.therapist_name.substring(0,18)}...`
                                         : therapistInfo?.therapist_name} */}
                                        {therapistInfo?.therapist_name} 
                                    </Typography>
                                </div>
                                <div className='mobile-credentials'>
                                    <Typography
                                        color='color-4'
                                        variant='size-12'
                                    >
                                        {therapistInfo?.therapist_credentials}
                                    </Typography>
                                </div>
                                <div className='row'>
                                    <div className='col-6 col-md-6'>
                                        <div className='mobile-expertise'>
                                            <Typography
                                                variant='size-14'
                                                style={{ color: '#929AA6' }}
                                                weight='bold'
                                            >
                                                {'EXPERTISE\n'}
                                            </Typography>
                                            {therapistInfo?.specialities &&
                                            therapistInfo.specialities.length >
                                                0 ? (
                                                therapistInfo.specialities
                                                    .slice(0, 4)
                                                    .map(
                                                        (speciality, index) => (
                                                            <Typography
                                                                variant='size-14'
                                                                key={index}
                                                            >
                                                                {speciality}
                                                            </Typography>
                                                        )
                                                    )
                                            ) : (
                                                <Typography variant='size-14'>
                                                    N/A
                                                </Typography>
                                            )}
                                        </div>
                                        <div className='mobile-insurance'>
                                            <Typography
                                                className='.heading-color'
                                                variant='size-14'
                                                style={{ color: '#929AA6' }}
                                                weight='bold'
                                            >
                                                {'INSURANCE\n'}
                                            </Typography>
                                            {therapistInfo?.insurances?.length >
                                            0 ? (
                                                <Typography variant='size-14'>
                                                    Insurance accepted
                                                </Typography>
                                            ) : (
                                                <Typography variant='size-14'>
                                                    Not accepted insurance
                                                </Typography>
                                            )}
                                        </div>
                                    </div>
                                    <div className='col-6 col-md-6'>                                   
                                        <div className='mobile-availability'>
                                            <Typography
                                                variant='size-14'
                                                style={{ color: '#929AA6' }}
                                                weight='bold'
                                            >
                                                {'MEETING AVAILABILITY\n'}
                                            </Typography>
                                            <div className='availability-grid'>
                                                <div className='d-inline-flex mb-2'>
                                                    {therapistInfo.meeting_availability.length > 0
                                                         &&
                                                        getMeetingAvailabilityGradient(
                                                            therapistInfo.meeting_availability[0],
                                                            therapistInfo
                                                        ).icons}
                                                    {therapistInfo.meeting_availability.length > 0
                                                         && (
                                                        <Typography
                                                            className='mt-2 '
                                                        >
                                                            {therapistInfo.meeting_availability.length > 0
                                                                 &&
                                                                getMeetingAvailabilityGradient(
                                                                    therapistInfo.meeting_availability[0],
                                                                    therapistInfo
                                                                ).label}
                                                        </Typography>
                                                    )}
                                                </div>
                                                {therapistInfo.meeting_availability.lengh ===
                                                    0 ||
                                                    therapistInfo.meeting_availability ===
                                                        undefined && (
                                                        <Typography className='ms-2 mb-4' >
                                                       
                                                            N/A
                                                        </Typography>
                                                    )}
                                            </div>
                                        </div>
                                        <div className='mobile-office-location'>
                                            <Typography
                                                variant='size-14'
                                                style={{ color: '#929AA6' }}
                                                weight='bold'
                                            >
                                                {'IN PERSON OFFICE\n'}
                                            </Typography>

                                            {therapistInfo?.therapy_location.length > 0 ? (
                                                <Typography variant='size-14'>
                                                    {
                                                        therapistInfo?.therapy_location[0]
                                                    }
                                                </Typography>
                                            ) : (
                                                <Typography variant='size-14'>
                                                    N/A
                                                </Typography>
                                            )}
                                        </div>
                                        <div className='mobile-intake-fee'>
                                            <Typography
                                                variant='size-14'
                                                style={{ color: '#929AA6' }}
                                                weight='bold'
                                            >
                                                {'CASH-PAY INTAKE FEE\n'}
                                            </Typography>
                                            <Typography variant='size-14'>
                                                {'$' +
                                                    therapistInfo?.session_fee}
                                            </Typography>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='back-btn'>
                            <FontAwesomeIcon
                                icon={faArrowLeftLong}
                                className='arrow-left ms-2 mt-1'
                                size='sm'
                            />
                            <button
                                className='backAvailability btn  btn-transparent'
                                onClick={handleBackClick}
                            >
                                Back to Availability
                            </button>
                        </div>
                    </>
                ),
                isWithCancelButton: false,
                size: 'lg',
                title: 'Clinician Details',
                className: 'therapist-detail-mobile'
            })
        );
    };

    return (
        <div className="button-arrow">
            <button
                onClick={handleClick}
                className="viewdetails btn  btn-transparent "
            >
                View Details
            </button>

            <FontAwesomeIcon
                icon={faArrowRight}
                className="arrow-right p-1"
                size="xs"
            />
        </div>
    );
};

export default ClinicianMobileDetails;

